import type {
	Conditions,
	EventBBGMWithoutKey,
	FeedbackTier,
	LogEventSaveOptions,
	LogEventShowOptions,
	Phase,
	DistributiveOmit,
} from "./types.ts";

// Really, pids, tids, and type should not be optional if saveToDb is true
type LogEventOptions = {
	extraClass?: string;
	hideInLiveGame?: boolean;
	htmlIsSafe?: boolean;
	onClose?: () => void;
	persistent?: boolean;
	redirect?: { url: string; text: string; textKey?: string };
	saveToDb?: boolean;
	showNotification?: boolean;
	tier?: FeedbackTier;
	phaseMoment?: { phase: Phase; autoAdvance: boolean };
	momentTeamColors?: [string, string, string];
} & DistributiveOmit<EventBBGMWithoutKey, "season">;

export const createLogger = (
	saveEvent: (a: LogEventSaveOptions) => Promise<number | undefined>,
	showEvent: (a: LogEventShowOptions, conditions?: Conditions) => void,
) => {
	const logEvent = async (
		{
			extraClass,
			hideInLiveGame,
			htmlIsSafe,
			onClose,
			persistent = false,
			redirect,
			saveToDb = true,
			showNotification = true,
			tier,
			phaseMoment,
			momentTeamColors,
			...event
		}: LogEventOptions,
		conditions?: Conditions,
	) => {
		let result;
		if (saveToDb) {
			if (event.pids === undefined && event.tids === undefined) {
				throw new Error("Saved event must include pids or tids");
			}

			result = await saveEvent(event);
		}

		if (showNotification && event.text) {
			showEvent(
				{
					extraClass,
					hideInLiveGame,
					htmlIsSafe,
					onClose,
					persistent,
					redirect,
					text: event.text,
					textKey: "textKey" in event ? event.textKey : undefined,
					textParams: "textParams" in event ? event.textParams : undefined,
					tier,
					phaseMoment,
					momentTeamColors,
					type: event.type,
				},
				conditions,
			);
		}

		return result;
	};

	return logEvent;
};
